const fitpass = (state = { userCoords: null, customCoords: null, customLocationName: '' }, action) => {
  switch (action.type) {
    case 'FITPASS_SET_COORDS':
      return { ...state, userCoords: action.payload };
    case 'FITPASS_SET_CUSTOM_LOCATION':
      return { ...state, customCoords: action.payload.coords, customLocationName: action.payload.locationName };
    default:
      return state;
  }
};

export default fitpass;
